import React from "react";
import styled from "styled-components";
import { MdClose } from "react-icons/md";
import { IconButton } from "@material-ui/core";

const Wrapper = styled.div`
  display: flex;
  padding: 14px 0px;
  margin: 0px 24px;
  align-items: center;

  border-bottom: 1px solid #eae5e5;
`;

const Count = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  line-height: 23px;

  color: #c41230;
  margin: 0px 22px 0px 0px;
`;

const Label = styled.div`
  color: #080808;
  opacity: 0.8;
  font-size: 16px;
  line-height: 20px;
`;

const SubLabel = styled.div`
  color: #666666;
  font-size: 12px;
  line-height: 15px;
  opacity: 0.6;
`;

function DistributorMenuItem({
  onClick,
  name,
  count,
  address,
}: IDistributorMenuItem) {
  return (
    <Wrapper>
      <Count>{count}</Count>
      <div>
        <Label>{name}</Label>
        <SubLabel>{address}</SubLabel>
      </div>
      <IconButton style={{ marginLeft: "auto" }} onClick={onClick}>
        <MdClose
          style={{
            fontSize: "16px",
            color: "#666666",
            opacity: 0.6,
          }}
        />
      </IconButton>
    </Wrapper>
  );
}

export interface IDistributorMenuItem {
  name: string;
  count: number;
  address: string;
  onClick: () => void;
}

export default DistributorMenuItem;
